import styles from "./styles.module.css";
import { useEffect, useState, useContext } from "react";
import Modal from "../../../modal";
import { MdClose } from "react-icons/md";
import { useParams } from "react-router-dom";
import { createTable, createRole } from "../../../utils/databaseactions";
import { AppDisbatch, AppValue } from "../../../contexts/app";
import { DatabaseValue } from "../../../contexts/database";
import { UserValue } from "../../../contexts/user";
import { useQueryClient } from "react-query";

export default function Add({ title = "Table" }) {
  const [fnIsRunning, setFnIsRunning] = useState(false);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [loadingTitle, setLoadingTitle] = useState("");
  const { appId } = useParams();
  const queryClient = useQueryClient();
  const disbatch = useContext(AppDisbatch);
  const context = useContext(DatabaseValue);
  const user = useContext(UserValue);
  const app = useContext(AppValue);

  useEffect(() => {
    if (!open) {
      setName("");
      setFnIsRunning(false);
    }
  }, [open]);

  const handleNewTable = () => {
    if (!nameIsValid(name)) {
      console.log("name is invalid");
    }
    if (nameExists()) {
      console.log(`A table already exists with the name ${name}`);
    } else {
      setLoadingTitle(`Creating ${name} Table.`);
      setFnIsRunning(true);
      let n = name.replaceAll(" ", "");
      const query = createTable(appId, n, user);
      query
        .then((data) => {
          if (data.err) throw new Error(data.err);
          queryClient.invalidateQueries("roleData");
        })
        .catch((err) => console.log(err))
        .finally(() => setOpen(false));
    }
  };

  const handleNewRole = () => {
    if (!nameIsValid(name)) {
      console.log("name is invalid");
    } else {
      setLoadingTitle(`Creating ${name} Role.`);
      setFnIsRunning(true);
      const n = name.replaceAll(" ", "");
      const tables = context.map((cur) => cur.id);
      createRole(appId, tables, n, user)
        .then((data) => {
          if (data.err) throw new Error("an error occurred");
          disbatch({ type: "addRole", id: data._id, name: data.name });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => setOpen(false));
    }
  };

  const nameIsValid = (str) => {
    const validChars = "abcdefghijklmnopqrstuvwxyz";
    try {
      if (name === null || name.replaceAll(" ", "") === "") {
        return false;
      }
      for (let i = 0; i < str.length; i++) {
        let c = str.charAt(i).toLowerCase();
        if (!validChars.includes(c)) return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  };

  const nameExists = () => {
    const names = context.map((table) => table.name.toLowerCase());
    return names.includes(name.toLowerCase());
  };

  return (
    <div className={styles.add} onClick={() => setOpen(true)}>
      <div>NEW TABLE</div>
      <Modal onClose={() => setOpen(false)} open={open}>
        <div className={styles.form}>
          {fnIsRunning ? (
            <div className={styles.formContainer}>
              <div className={styles.text}>{loadingTitle}</div>
            </div>
          ) : (
            <>
              <div className={styles.formTitle}>
                New {title}{" "}
                <MdClose onClick={() => setOpen(false)} className="icon" />
              </div>
              <div className={styles.formContainer}>
                <div className={styles.formInputTitle}>{title} Name</div>
                <input
                  autoFocus
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="name..."
                  className="input"
                />
              </div>
              <div className={styles.formContainer}>
                <button
                  disabled={name.length === 0}
                  onClick={title === "Table" ? handleNewTable : handleNewRole}
                >
                  Submit
                </button>
              </div>
            </>
          )}
        </div>
      </Modal>
    </div>
  );
}
